import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static get targets() {
    return ["buttons", "approveBtn", "rejectBtn", "approveConfirm", "rejectConfirm"]
  }

  static get values() {
    return {
      memorialSlug: String,
      photoId: String
    }
  }

  confirmApprove() {
    this.showConfirm("approve")
  }

  confirmReject() {
    this.showConfirm("reject")
  }

  abort() {
    this.showConfirm(null)
  }

  showConfirm(which) {
    const disabled = Boolean(which)
    this.approveBtnTarget.disabled = disabled
    this.rejectBtnTarget.disabled = disabled
    this.buttonsTarget.classList.toggle("confirmation-options", disabled)
    this.approveConfirmTarget.hidden = which !== "approve"
    this.rejectConfirmTarget.hidden = which !== "reject"
  }

  approve() {
    this.moderate("approve")
  }

  reject() {
    this.moderate("reject")
  }

  async moderate(action) {
    const target = action === "approve" ? this.approveConfirmTarget : this.rejectConfirmTarget

    try {
      const response = await fetch(
        `/${this.memorialSlugValue}/photos/${this.photoIdValue}/${action}`,
        {
          method: "PUT",
          headers: {
            "X-CSRF-Token": this.csrfToken,
            Accept: "application/json"
          }
        }
      )

      if (!response.ok) {
        throw new Error("Failed to moderate photo")
      }

      target.textContent =
        action === "approve" ? "Photo successfully accepted." : "Photo successfully rejected."
    } catch (error) {
      target.textContent = "Something went wrong."
    }
  }

  get csrfToken() {
    const csrfMetaTag = document.querySelector("meta[name='csrf-token']")
    return csrfMetaTag ? csrfMetaTag.content : ""
  }
}
